import React, { useContext } from 'react';
import { Box, ProgressIndicator } from '@applyboard/crystal-ui';
import { ProgressBarContext } from "../../CEF/Providers";
function Progress() {
  var _useContext = useContext(ProgressBarContext),
    completion = _useContext.completion;
  return /*#__PURE__*/React.createElement(Box, {
    pb: 6
  }, /*#__PURE__*/React.createElement(ProgressIndicator, {
    variant: "linear",
    value: completion,
    "aria-label": "Questions complete"
  }));
}
export default Progress;